(function () {
  const SELECTOR = "slider-component[data-xts-contained-carousel]";
  const RECOMMENDATIONS_SELECTOR = "product-recommendations.related-products";
  const watchedRecommendations = new WeakSet();

  function getColumns(component) {
    const isDesktop = window.matchMedia("(min-width: 990px)").matches;
    const isTablet = window.matchMedia("(min-width: 768px)").matches;
    const value = isDesktop
      ? component.dataset.columnsDesktop
      : isTablet
        ? 2
        : component.dataset.columnsMobile;
    const columns = Number.parseInt(value, 10);
    return Number.isFinite(columns) && columns > 0 ? columns : 1;
  }

  function initContainedCarousel(component) {
    if (component.dataset.xtsContainedCarouselInit === "true") return;

    const slider = component.querySelector('[id^="Slider-"]');
    const prevButton = component.querySelector('button[name="previous"]');
    const nextButton = component.querySelector('button[name="next"]');
    const controls = component.querySelector(".slider-buttons");
    const currentElement = component.querySelector(".slider-counter--current");
    const totalElement = component.querySelector(".slider-counter--total");

    if (!slider || !prevButton || !nextButton) return;

    component.dataset.xtsContainedCarouselInit = "true";
    component.enableSliderLooping = true;

    let scrollTimer;
    let resizeTimer;
    let slideIndex = 0;
    let cloneCount = 0;
    let isProgrammaticScroll = false;
    let pointerStartX = 0;
    let pointerStartY = 0;
    let pointerIsDown = false;
    let suppressClick = false;
    let wheelTimer;

    function mod(value, total) {
      return ((value % total) + total) % total;
    }

    function getSlides() {
      return Array.from(slider.querySelectorAll(".grid__item")).filter(
        (item) => item.clientWidth > 0
      );
    }

    function getRealSlides() {
      return getSlides().filter((item) => item.dataset.xtsClone !== "true");
    }

    function getTrackIndexForSlideIndex(index) {
      return cloneCount + index;
    }

    function getSlideIndexFromTrackIndex(index) {
      const realCount = getRealSlides().length;
      if (!realCount) return 0;

      return mod(index - cloneCount, realCount);
    }

    function makeCloneIdMap(clone) {
      const idMap = new Map();

      clone.querySelectorAll("[id]").forEach((element, index) => {
        const oldId = element.id;
        const newId = `${oldId}--xts-clone-${Date.now()}-${index}`;
        idMap.set(oldId, newId);
        element.id = newId;
      });

      return idMap;
    }

    function replaceIdRefs(clone, idMap) {
      const refAttributes = [
        "aria-controls",
        "aria-describedby",
        "aria-labelledby",
        "for",
        "form",
        "list",
      ];

      clone.querySelectorAll(refAttributes.map((attr) => `[${attr}]`).join(",")).forEach(
        (element) => {
          refAttributes.forEach((attr) => {
            const value = element.getAttribute(attr);
            if (!value) return;

            const nextValue = value
              .split(/\s+/)
              .map((id) => idMap.get(id) || id)
              .join(" ");
            element.setAttribute(attr, nextValue);
          });
        }
      );
    }

    function createClone(slide) {
      const clone = slide.cloneNode(true);
      const idMap = makeCloneIdMap(clone);
      replaceIdRefs(clone, idMap);
      clone.dataset.xtsClone = "true";
      clone.classList.add("xts-contained-carousel__clone");
      clone.removeAttribute("id");
      return clone;
    }

    function removeClones() {
      slider
        .querySelectorAll('[data-xts-clone="true"]')
        .forEach((clone) => clone.remove());
    }

    function buildClones() {
      removeClones();

      const realSlides = getRealSlides();
      if (realSlides.length <= getColumns(component)) {
        cloneCount = 0;
        return;
      }

      cloneCount = Math.min(getColumns(component), realSlides.length);

      const beforeFragment = document.createDocumentFragment();
      realSlides.slice(-cloneCount).forEach((slide) => {
        beforeFragment.appendChild(createClone(slide));
      });

      const afterFragment = document.createDocumentFragment();
      realSlides.slice(0, cloneCount).forEach((slide) => {
        afterFragment.appendChild(createClone(slide));
      });

      slider.prepend(beforeFragment);
      slider.append(afterFragment);
    }

    function getNearestTrackIndex() {
      const slides = getSlides();
      if (!slides.length) return 0;

      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;
      slides.forEach((slide, index) => {
        const distance = Math.abs(getRawTargetLeft(slide) - slider.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function getRawTargetLeft(slide) {
      const sliderRect = slider.getBoundingClientRect();
      const slideRect = slide.getBoundingClientRect();
      return slideRect.left - sliderRect.left + slider.scrollLeft;
    }

    function getTargetLeft(trackIndex) {
      const slides = getSlides();
      if (!slides.length) return 0;

      const safeTrackIndex = Math.max(0, Math.min(trackIndex, slides.length - 1));
      const maxLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);

      return Math.max(0, Math.min(getRawTargetLeft(slides[safeTrackIndex]), maxLeft));
    }

    function update() {
      const realSlides = getRealSlides();
      const isScrollable = realSlides.length > getColumns(component);

      slideIndex = getSlideIndexFromTrackIndex(getNearestTrackIndex());

      if (currentElement) currentElement.textContent = slideIndex + 1;
      if (totalElement) totalElement.textContent = realSlides.length;

      prevButton.disabled = !isScrollable;
      nextButton.disabled = !isScrollable;
      if (controls) {
        controls.hidden = !isScrollable;
        controls.style.display = isScrollable ? "" : "none";
      }
    }

    function normalizePosition() {
      const realSlides = getRealSlides();
      if (!realSlides.length || !cloneCount) return;

      const trackIndex = getNearestTrackIndex();
      const firstRealTrackIndex = cloneCount;
      const lastRealTrackIndex = cloneCount + realSlides.length - 1;

      if (trackIndex < firstRealTrackIndex || trackIndex > lastRealTrackIndex) {
        slideIndex = getSlideIndexFromTrackIndex(trackIndex);
        scrollToTrackIndex(getTrackIndexForSlideIndex(slideIndex), "auto");
      }
    }

    function scrollToTrackIndex(trackIndex, behavior = "smooth") {
      isProgrammaticScroll = behavior === "smooth";
      slider.scrollTo({
        left: getTargetLeft(trackIndex),
        behavior,
      });

      if (behavior !== "smooth") {
        isProgrammaticScroll = false;
      }
    }

    function goToSlide(index, behavior = "smooth") {
      const realSlides = getRealSlides();
      if (!realSlides.length) return;

      const realCount = realSlides.length;
      const targetSlideIndex = mod(index, realCount);
      let targetTrackIndex = getTrackIndexForSlideIndex(targetSlideIndex);

      if (slideIndex === 0 && index < 0) {
        targetTrackIndex = cloneCount - 1;
      } else if (slideIndex === realCount - 1 && index >= realCount) {
        targetTrackIndex = cloneCount + realCount;
      }

      slideIndex = targetSlideIndex;
      scrollToTrackIndex(targetTrackIndex, behavior);
      window.setTimeout(() => {
        isProgrammaticScroll = false;
        normalizePosition();
        update();
      }, behavior === "smooth" ? 320 : 0);
    }

    function snapToNearest(behavior = "smooth") {
      const trackIndex = getNearestTrackIndex();
      slideIndex = getSlideIndexFromTrackIndex(trackIndex);
      scrollToTrackIndex(trackIndex, behavior);
      window.setTimeout(() => {
        isProgrammaticScroll = false;
        normalizePosition();
        update();
      }, behavior === "smooth" ? 260 : 0);
    }

    function onControlClick(event, direction) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (getRealSlides().length <= getColumns(component)) return;
      goToSlide(slideIndex + direction);
    }

    function moveByDirection(direction) {
      if (getRealSlides().length <= getColumns(component)) return;
      goToSlide(slideIndex + direction);
    }

    prevButton.addEventListener(
      "click",
      (event) => onControlClick(event, -1),
      true
    );
    nextButton.addEventListener(
      "click",
      (event) => onControlClick(event, 1),
      true
    );

    slider.addEventListener("pointerdown", (event) => {
      if (!event.isPrimary || event.button !== 0) return;

      pointerIsDown = true;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
    });

    slider.addEventListener("pointerup", (event) => {
      if (!pointerIsDown || !event.isPrimary) return;

      const deltaX = event.clientX - pointerStartX;
      const deltaY = event.clientY - pointerStartY;
      pointerIsDown = false;

      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) {
        return;
      }

      event.preventDefault();
      suppressClick = true;
      moveByDirection(deltaX < 0 ? 1 : -1);
      window.setTimeout(() => {
        suppressClick = false;
      }, 0);
    });

    slider.addEventListener("pointercancel", () => {
      pointerIsDown = false;
    });

    slider.addEventListener(
      "click",
      (event) => {
        if (!suppressClick) return;

        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );

    slider.addEventListener(
      "wheel",
      (event) => {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

        event.preventDefault();
        if (wheelTimer) return;

        moveByDirection(event.deltaX > 0 ? 1 : -1);
        wheelTimer = window.setTimeout(() => {
          wheelTimer = undefined;
        }, 420);
      },
      { passive: false }
    );

    slider.addEventListener(
      "scroll",
      () => {
        update();
        if (isProgrammaticScroll) return;

        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => snapToNearest("smooth"), 120);
      },
      { passive: true }
    );

    window.addEventListener("resize", () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        component.style.setProperty(
          "--xts-contained-carousel-columns",
          getColumns(component)
        );
        buildClones();
        goToSlide(slideIndex, "auto");
        update();
      }, 150);
    });

    component.xtsContainedCarouselRefresh = function (resetPosition = false) {
      component.style.setProperty(
        "--xts-contained-carousel-columns",
        getColumns(component)
      );
      buildClones();
      goToSlide(resetPosition ? 0 : slideIndex, "auto");
      update();
    };

    component.style.setProperty(
      "--xts-contained-carousel-columns",
      getColumns(component)
    );
    requestAnimationFrame(() => {
      buildClones();
      goToSlide(0, "auto");
      update();
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initContainedCarousel);
    document
      .querySelectorAll(RECOMMENDATIONS_SELECTOR)
      .forEach(watchRecommendations);
  }

  function watchRecommendations(container) {
    if (watchedRecommendations.has(container)) return;
    watchedRecommendations.add(container);

    const observer = new MutationObserver(() => {
      container.querySelectorAll(SELECTOR).forEach(initContainedCarousel);
    });

    observer.observe(container, { childList: true, subtree: true });
    container.querySelectorAll(SELECTOR).forEach(initContainedCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
